import React from "react";

export default function SocialPostSkeleton() {
  return (
    <>
      <style>
        {` 
  .card {
    background: #ededf5;
    border-radius: 6px;
    padding: 20px;
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    box-shadow: 0 4px 24px rgba(120,80,200,.08);
  }

  /* ── SHIMMER ── */
  @keyframes shimmer {
    0%   { background-position: -600px 0; }
    100% { background-position:  600px 0; }
  }

  .sk {
    background: linear-gradient(
      90deg,
      #ddd6fe 25%,
      #c4b5fd 50%,
      #ddd6fe 75%
    );
    background-size: 600px 100%;
    animation: shimmer 1.5s infinite linear;
    border-radius: 6px;
  }

  /* ── Social Icons Row ── */
  .icons-row {
    display: flex;
    gap: 15.5px;
    align-items: center;
  }

  .sk-icon {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* First icon has a ring (selected state) */
  .sk-icon.selected {
    box-shadow: 0 0 0 3px #fff, 0 0 0 5px #c4b5fd;
  }

  /* ── Text Area Box ── */
  .textbox {
    background: #fff;
    border-radius: 12px;
    padding: 18px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 300px;
  }

  .sk-line       { height: 13px; width: 100%; }
  .sk-line.w90   { width: 90%; }
  .sk-line.w95   { width: 95%; }
  .sk-line.w75   { width: 75%; }
  .sk-line.w55   { width: 55%; }

  /* ── Button ── */
  .sk-btn {
    height: 80px;
    border-radius: 12px;
    width: 100%;
  }`}
      </style>
      <div className="card">
        {/* Social platform icons */}
        <div className="icons-row">
          <div className="sk sk-icon selected"></div>
          <div className="sk sk-icon"></div>
          <div className="sk sk-icon"></div>
          <div className="sk sk-icon"></div>
          <div className="sk sk-icon"></div>
        </div>

        {/* Post text area */}
        <div className="textbox">
          <div className="sk sk-line w95"></div>
          <div className="sk sk-line w100"></div>
          <div className="sk sk-line w90"></div>
          <div className="sk sk-line w95"></div>
          <div className="sk sk-line w75"></div>
          <div className="sk sk-line w55"></div>
        </div>

        {/* Create Post button */}
        <div className="sk sk-btn "></div>
      </div>
    </>
  );
}
